import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  ISignInRes,
  ISignInInput,
  ISignUpRes,
  ISignUpInput,
  IRegisterPasswordlessRes,
  IRegisterPasswordlessInput,
  IPasswordResetWithPasswordInput,
  IConfirmNumberInput,
  IConfirmNumberData,
  IPasswordResetWithPasswordData,
  ISignInWithMagicLinkRes,
  ISignInWithMagicLinkInput,
  ISignInWithEmailMagicLinkRes,
  ISignInWithEmailMagicLinkInput,
  ISignInWithSmsMagicLinkRes,
  ISignInWithSmsMagicLinkInput,
} from '@shared/models/auth';
import {
  IUpdatePhoneNumberInput,
  IUpdatePhoneNumberData,
} from '@shared/models/profile';

import { MUTATION_ERROR_FRAGMENT } from '../errors.fragments';
import {
  SIGN_IN_WITH_EMAIL_MAGIC_LINK_FRAGMENT,
  SIGN_IN_WITH_MAGIC_LINK_FRAGMENT,
  SIGN_IN_WITH_SMS_MAGIC_LINK_FRAGMENT,
  USER_FRAGMENT,
  USER_WITH_TOKEN_FRAGMENT,
} from '@graphql/fragments/auth.fragments';

export const SIGN_IN: TypedDocumentNode<ISignInRes, ISignInInput> = gql`
  ${USER_WITH_TOKEN_FRAGMENT}
  mutation signInWithPassword($email: String!, $password: String!) {
    signInWithPassword(email: $email, password: $password) {
      ...UserWithTokenFragment
    }
  }
`;

export const SIGN_IN_WITH_MAGIC_LINK: TypedDocumentNode<
  ISignInWithMagicLinkRes,
  ISignInWithMagicLinkInput
> = gql`
  ${SIGN_IN_WITH_MAGIC_LINK_FRAGMENT}
  mutation signInWithMagicLink($token: String!) {
    signInWithMagicLink(token: $token) {
      ...MagicLinkUserWithTokenFragment
    }
  }
`;

export const SIGN_IN_WITH_EMAIL_MAGIC_LINK: TypedDocumentNode<
  ISignInWithEmailMagicLinkRes,
  ISignInWithEmailMagicLinkInput
> = gql`
  ${SIGN_IN_WITH_EMAIL_MAGIC_LINK_FRAGMENT}
  mutation signInWithEmailMagicLink($token: String!) {
    signInWithEmailMagicLink(token: $token) {
      ...SignInWithEmailMagicLinkFragment
    }
  }
`;

export const SIGN_IN_WITH_SMS_MAGIC_LINK: TypedDocumentNode<
  ISignInWithSmsMagicLinkRes,
  ISignInWithSmsMagicLinkInput
> = gql`
  ${SIGN_IN_WITH_SMS_MAGIC_LINK_FRAGMENT}
  mutation signInWithSmsMagicLink($token: String!) {
    signInWithSmsMagicLink(token: $token) {
      ...SignInWithSmsMagicLinkFragment
    }
  }
`;

export const SIGN_UP: TypedDocumentNode<ISignUpRes, ISignUpInput> = gql`
  ${USER_FRAGMENT}
  ${MUTATION_ERROR_FRAGMENT}
  mutation registerWithPassword($input: RegisterWithPasswordInput!) {
    registerWithPassword(input: $input) {
      metadata {
        token
      }
      result {
        ...UserFragment
      }
      errors {
        ...ErrorFragment
      }
    }
  }
`;

export const REGISTER_PASSWORDLESS: TypedDocumentNode<
  IRegisterPasswordlessRes,
  IRegisterPasswordlessInput
> = gql`
  ${USER_FRAGMENT}
  ${MUTATION_ERROR_FRAGMENT}
  mutation registerPasswordless($input: RegisterPasswordlessInput!) {
    registerPasswordless(input: $input) {
      metadata {
        token
      }
      result {
        ...UserFragment
      }
      errors {
        ...ErrorFragment
      }
    }
  }
`;

export const PASSWORD_RESET_WITH_PASSWORD: TypedDocumentNode<
  IPasswordResetWithPasswordData,
  IPasswordResetWithPasswordInput
> = gql`
  ${MUTATION_ERROR_FRAGMENT}
  mutation passwordResetWithPassword(
    $email: String!
    $input: PasswordResetWithPasswordInput!
  ) {
    passwordResetWithPassword(email: $email, input: $input) {
      metadata {
        token
      }
      errors {
        ...ErrorFragment
      }
    }
  }
`;

export const CONFIRM_PHONE_NUMBER: TypedDocumentNode<
  IConfirmNumberData,
  IConfirmNumberInput
> = gql`
  ${USER_FRAGMENT}
  ${MUTATION_ERROR_FRAGMENT}
  mutation confirmPhoneNumber($input: ConfirmPhoneNumberInput!) {
    confirmPhoneNumber(input: $input) {
      result {
        ...UserFragment
      }
      errors {
        ...ErrorFragment
      }
    }
  }
`;

export const UPDATE_PHONE_NUMBER: TypedDocumentNode<
  IUpdatePhoneNumberData,
  IUpdatePhoneNumberInput
> = gql`
  ${USER_FRAGMENT}
  ${MUTATION_ERROR_FRAGMENT}
  mutation updatePhoneNumber($input: UpdatePhoneNumberInput!) {
    updatePhoneNumber(input: $input) {
      result {
        ...UserFragment
      }
      errors {
        ...ErrorFragment
      }
    }
  }
`;
